<template>
  <div class="card card-default">
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <button type="button" class="btn btn-info" @click="addNewPackage()">
            Create New DNS View
          </button>
        </div>
      </div>
      <div class="row row-spacing">
        <div class="col-md-12">
          <div
            class="table-responsive table-bordered"
            v-if="dnsViews.length > 0"
          >
            <table class="table">
              <thead>
                <tr class="text-nowrap">
                  <th>Client Number</th>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Default Origin</th>
                  <th>Command Subject</th>
                  <th>DNS Servers</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="dnsView in dnsViews"
                  :key="dnsView.dnsViewNumber"
                >
                  <td>{{ dnsView.clientNumber }}</td>
                  <td>{{ dnsView.name }}</td>
                  <td class="wrap-text">{{ dnsView.description }}</td>
                  <td>{{ dnsView.defaultOrigin }}</td>
                  <td>{{ dnsView.commandSubject }}</td>
                  <td class="wrap-text">{{ dnsView.nsServerHostNames }}</td>
                  <td class="text-center">
                    <button
                      v-tooltip="'Edit Package'"
                      type="button"
                      @click="editPackage(dnsView)"
                      class="btn btn-sm btn-info m-1"
                    >
                      <em class="fa fa-edit fa-fw"></em>
                    </button>
                    <button
                      v-tooltip="'Delete Package'"
                      type="button"
                      @click="deletePackage(dnsView)"
                      class="btn btn-sm btn-primary"
                    >
                      <em class="fa fa-trash fa-fw"></em>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="alert alert-info">
            No DNS Views Available
          </div>
        </div>
      </div>
      <ModifyDnsViewModal
        ref="modifyPackageModal"
        :dnsView="selectedDnsView"
        @packageEdited="loadDnsViews()"
      />
    </div>
  </div>
</template>
  
<script>
  import PriceFunctions from "@/components/Admin/PriceFunctions";
  import ModifyDnsViewModal from "@/components/Admin/Modals/ModifyDnsViewModal";
  
  export default {
    extends: PriceFunctions,
    components: {
        ModifyDnsViewModal,
    },
    data() {
      return {
        dnsViews: [],
        period: this.getCurrentPeriod(),
        newDnsView: {},
        selectedDnsView: {},
      };
    },
    mounted() {
      this.setPageTitle();
      this.loadDnsViews();
    },
    methods: {
      setPageTitle: function() {
          this.$root.$emit("SET_PAGE_TITLE", this.$route.meta.title);
      },
      loadDnsViews() {
        this.$http
          .get(
            this.$config.aimsAPI +
              "pricing/dnsviews"
          )
          .then(
            (response) => {
              this.newDnsView = response.data;
              this.dnsViews = _.orderBy(response.data.dnsviews, 'clientNumber', 'asc');
            },
            (error) => {
              console.error(error);
              this.showError("Error Fetching DNS Views", error);
            }
          );
      },
      addNewPackage() {
        this.selectedDnsView = this.deepCopyObject(this.newDnsView);
        this.$refs.modifyPackageModal.open();
      },
      editPackage(dnsView) {
        this.selectedDnsView = this.deepCopyObject(dnsView);
        this.$refs.modifyPackageModal.open();
      },
      savePackage(dnsView) {
        this.saveData(dnsView).then(
          () => {
            this.showSuccess("Successfully Saved DNS View");
            this.loadDnsViews();
          },
          (error) => {
            this.showError("Error Saving DNS View", error);
          }
        );
      },
      deletePackage(dnsView) {
        this.$swal({
          title: "Are you sure you want to delete this DNS View?",
          type: "warning",
          showCancelButton: true,
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
        }).then((result) => {
          if (result.value) {
            this.$http.delete( this.$config.aimsAPI + "pricing/dnsviews/" + dnsView.dnsViewNumber)
              .then(
                (response) => {
                  this.showSuccess(response.data.message);
                  this.loadDnsViews();
                },
                (error) => {
                  this.showError("Error Deleting DNS View", error);
                }
              );
          }
        });
      },
    },
  };
</script>
  